import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { ShapesDetails } from './ShapeDetails';
import { ShapesList } from './ShapesList';

const ShapesPanelContainer = styled.div`
    padding: 0 20px !important;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ShapesPanel = () => {
    const { store } = useAdvancedEditorContext();

    const isShapeSelected = !!store.selectedShapes.length;

    return (
        <ShapesPanelContainer data-testid="shape-panel">
            {isShapeSelected && <ShapesDetails />}
            {!isShapeSelected && <ShapesList />}
        </ShapesPanelContainer>
    );
};
